import { openNotification } from "../globals/Components/Notification/Notification";
import validateMessages from "../globals/inputs/validateMessages";
import { MessageResponse } from "./system/types";

export const serverMessages = (responseData: any): MessageResponse=> {       
    let message: MessageResponse;
    const status = responseData.Error?.status ?? responseData.StatusCode;
    const errorMessage = responseData.Error?.message ?? "Error desconocido";
    if (responseData.Error.status != 400) {       
        message = {
            code: responseData.Error.status,
            message: [validateMessages.serverError+":"+ responseData.Error.message]
        };
        openNotification("Ups, algo no salió como esperábamos.", "Por favor, contacte al departamento de sistemas para que podamos ayudarle.")      
    }
    else {           
        message = {
            code: status,
            message: [errorMessage]
        };     
        openNotification("Advertencia", errorMessage)        
    }
    return message;  
};



export const serverMessagesNoOpenNotification = (responseData: any): MessageResponse=> {       
    let message: MessageResponse;
    if (responseData.Error.status != 400) {       
        message = {
            code: responseData.Error.status,
            message: ["Ups, algo no salió como esperábamos. Por favor, contacte al departamento de sistemas para que podamos ayudarle."]
        };        
    }
    else {        
        const errorResponse = responseData.Error.message;        
        message = {
            code: responseData.Error.status,
            message: [errorResponse]
        };           
        //openNotification("Advertencia", errorResponse)    
    }
    return message;  
};